<template>
	<div>
		<div class="title">保障信息</div>
		<Form :model="form" :label-width="110" ref="form" class="mt15">
			<FormItem label="保障类型：" class="w600" prop="policyTimeType" :rules="{required:true,message:'请选择保障类型',trigger:'change'}">	
				<RadioGroup v-model="form.policyTimeType" @on-change="dateChange('policyTimeType')">
					<Radio label="1">年单</Radio>
					<Radio label="2">月单</Radio>
				</RadioGroup>
			</FormItem>
			<FormItem label="保障起期：" class="w600" prop="beginDate" :rules="{required:true,message:'请选择保障起期',type:'date',trigger:'change'}">
				<DatePicker v-model="form.beginDate" type="date" placeholder="请选择保障起期" style="width: 100%" @on-change="dateChange('beginDate')" :options="dateOptions" transfer>
				</DatePicker>
				<span class="errorMsg">（T+1，周末和法定节假日需要顺延）</span>
			</FormItem>
			<FormItem label="保障止期：" class="w600" required>
				{{ form.endDate }}
			</FormItem>
		</Form>
		<div class="download-btn mt15">
			<Button @click="addClick">添加设备</Button>
			<UploadFile style="display:inline-block" url="/pc/specialEquipment/add/import" :data="uploadParams" :show-upload-list="false" btn-text="批量导入" @on-success="uploadSuccess" />
			<span class="downloadFile">
				<a @click="download">下载模板</a>
			</span>
		</div>
		<Table class="mt20" :columns="columns" :data="detailList" highlight-row disabled-hover>
			<template slot-scope="{ row, index }" slot="manage">
				<a @click="del(index)">删除</a>
				<a @click="editClick(row,index)">编辑</a>
			</template>
		</Table>
		<Modal
			v-model="addFacility"
			:title="addFacilityTitle"
			:mask-closable="false"
			@on-cancel="addFacilitycancel">
			<div>
				<Form v-if="addFacility" ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="110">
					<FormItem label="设备名称" prop="name">
						<Input v-model="formValidate.name" placeholder="请输入"></Input>
					</FormItem>
					<FormItem label="车架号/发动机号" prop="code">
						<Input v-model="formValidate.code" placeholder="请输入"></Input>
					</FormItem>
					<FormItem label="生产厂家" prop="productFactory">
						<Input v-model="formValidate.productFactory" placeholder="请输入"></Input>
					</FormItem>
					<FormItem label="使用区域" prop="useAddress">
						<Input v-model="formValidate.useAddress" placeholder="请输入"></Input>
					</FormItem>
					<FormItem label="费用承担主体" prop="feeBearGroup">
						<Select v-model="formValidate.feeBearGroup" filterable transfer clearable @on-change="structureChange">
							<Option :value="item.feeBearGroup" v-for="(item, index) in structureList" :key="index">{{ item.feeBearGroup }}</Option>
						</Select>
					</FormItem>
					<FormItem label="费用承担主体编码" prop="feeBearCode">
						<Select v-model="formValidate.feeBearCode" filterable transfer>
							<Option :value="item.code" v-for="(item, index) in feeBearList" clearable :key="index">{{ item.code }}</Option>
						</Select>
					</FormItem>
					<FormItem label="成本承担主体编码" prop="costBearCode">
						<Select v-model="formValidate.costBearCode" filterable transfer>
							<Option :value="item.code" v-for="(item, index) in costBearList" clearable :key="index">{{ item.code }}</Option>
						</Select>
					</FormItem>
				</Form>
			</div>
			<div slot="footer">
				<Button type="primary" @click="addFacilitycancel">取消</Button>
				<Button type="primary" @click="addFacilityok">确定</Button>
			</div>
		</Modal>	
	</div>
</template>
<script>
import UploadFile from '../common/UploadFile'
export default {
	components: { UploadFile },
	props: {
		info: Object,
	},
	data() {
		return {
			id: this.$route.params.id,
			columns: [
				{ title: '*设备名称', key: 'name', minWidth: 180 },
				{ title: '*车架号/发动机号', key: 'code', minWidth: 180 },
				{ title: '生产厂家', key: 'productFactory', minWidth: 180 },
				{ title: '使用区域', key: 'useAddress', minWidth: 180 },
				{ title: '*费用承担主体', key: 'feeBearGroup', minWidth: 180 },
				{ title: '*费用承担主体编码', key: 'feeBearCode', minWidth: 180 },
				{ title: '*成本承担主体编码', key: 'costBearCode', minWidth: 180 },
				{ title: '操作', slot: 'manage', fixed: 'right', width: 70 }
			],
			form: {
				policyTimeType:"1",
				beginDate:'',
				endDate:''
			},
			addFacilityTitle:'添加设备',
			addFacility:false,
			formValidate:{},
			ruleValidate:{
				name:{ required: true, message: '请输入设备名称', trigger: 'blur' },
				code:[{ required: true, message: '请输入车架号/发动机号', trigger: 'blur' },{ pattern: this.rules.alphanumeric, message: '格式不正确', trigger: 'blur' }
    			],
				productFactory:{ required: true, message: '请输入生产厂家', trigger: 'blur' },
				useAddress:{ required: true, message: '请输入使用区域', trigger: 'blur' },
				feeBearGroup:{ required: true, message: '请选择费用承担主体', trigger: 'change' },
				feeBearCode:{ required: true, message: '请选择费用承担主体编码', trigger: 'change' },
				costBearCode:{ required: true, message: '请选择成本承担主体编码', trigger: 'change' }			
			},
			dateOptions: {},
			endDateOptions:{},
			totalAmount:0,
			detailList: [],
			structureList: [], // 承担主体
			feeBearList:[], // 承担主体编码
			costBearList:[], // 成本承担主体编码
			editIndex:null
		}
	},
	computed: {
		uploadParams() {
			return {
				policyTimeType: this.form.policyTimeType,
				beginDate: this.formatDate(this.form.beginDate),
				endDate: this.formatDate(this.form.endDate)
			}
		}
	},
	watch: {
		info(v) {
			if(v){
				this.setData();
				this.setStartTimeOption().then(res=>{
					if(this.form.policyTimeType=='2'&&this.form.beginDate){
						this.$set(this.form,'endDate',res.defaultEndDate)
					}
				});
				this.getStructureList();
			}
		}
	},
	created() {
		this.setData();
		this.setStartTimeOption().then(res=>{
			if(this.form.policyTimeType=='2'&&this.form.beginDate){
				this.$set(this.form,'endDate',res.defaultEndDate)
			}
		});
		this.getStructureList();
	},
	methods: {
		download() {
			this.exportToExcel('/specialEquipment/insurance/devices/template')
		},
		editClick(row,index){
			this.addFacilityTitle = '编辑设备';
			this.addFacility = true;
			this.$nextTick(()=>{
				this.formValidate = this.jsonCopy(row);
				this.editIndex = index;
				if(row.feeBearCode){
					this.structureList.forEach(item=>{
						if(item.feeBearGroup==row.feeBearGroup){
							this.feeBearList = item.feeBearList; // 费用承担主体编码
						}
					})
				}
				if(row.costBearCode){
					this.structureList.forEach(item=>{
						if(item.feeBearGroup==row.feeBearGroup){
							this.costBearList = item.costBearList; // 成本承担主体
						}
					})
				}
			})
		},
		// 承担主体选中 级联费用承担主体编码，成本承担主体编码
		structureChange(val){
			this.$set(this.formValidate,'feeBearCode','')
			this.$set(this.formValidate,'costBearCode','')
			if(val){
				this.structureList.forEach(item=>{
					if(item.feeBearGroup==val){
						this.feeBearList = item.feeBearList; // 费用承担主体编码
						this.costBearList = item.costBearList; // 成本承担主体
					}
				})
			}
		},
		//获取承担主体
		getStructureList() {
			this.$axios.post('/specialEquipment/feeBear/structure.json').then((res) => {
				this.structureList = res
			})
		},
		addFacilityok(){
			this.$refs.formValidate.validate((valid) => {
				if (valid) {
					if(this.addFacilityTitle=='编辑设备'){
						let newList = this.detailList.map((item,index)=>{
							if(index==this.editIndex){
								item = this.formValidate;
							}
							return item
						})
						this.detailList = newList;
						this.editIndex = null;
					} else {
						this.detailList.unshift(this.formValidate)
					}
					this.addFacilitycancel();
					this.$nextTick(()=>{
						if(this.form.beginDate&&this.form.endDate){
							this.getPremium();
						}
					})
				}
			})
		},
		addFacilitycancel(){
			this.addFacility = false;
			this.formValidate = {};
		},
		async setStartTimeOption() {
			let dataTime = await this.getEffectiveDateEnd({
				beginDate: this.formatDate(this.form.beginDate)||this.formatDate(new Date()),
				policyTimeType: this.form.policyTimeType,
			}, 'start');
			if(this.form.policyTimeType=='1'){
				this.dateOptions = {
					disabledDate(date) {
						return date && (date.valueOf() < Date.parse(dataTime.earliestBeginDate + ' 00:00:00')||date.valueOf() > Date.parse(dataTime.defaultEndDate + ' 00:00:00'))
					}
				}
			} else {
				this.dateOptions = {
					disabledDate(date) {
						return date && (date.valueOf() < Date.parse(dataTime.earliestBeginDate + ' 00:00:00'))
					}
				}
			}
			if(this.form.policyTimeType=='1'&&this.form.beginDate){
				this.$set(this.form, 'endDate', dataTime.defaultEndDate)
			}
			if(this.form.policyTimeType=='2'&&this.form.beginDate){
				let beginDate = this.formatDate(this.form.beginDate)
				this.endDateOptions = {
					disabledDate(date) {
						return date && (date.valueOf() < Date.parse(beginDate+' 00:00:00'))||(date.valueOf() > Date.parse(dataTime.defaultEndDate + ' 00:00:00'))
					}
				}
			}
			return dataTime;
		},
		setData() {
			this.form = this.jsonCopy(this.info);
			if(this.info.policyTimeType){
				this.$set(this.form, 'policyTimeType', String(this.info.policyTimeType));
			} else {
				this.$set(this.form, 'policyTimeType', '1');
			}
			if (this.info.detailList) {
				this.detailList = this.info.detailList;
			}
			this.getPremium();
		},
		// 校验
		async val() {
			let flag = await this.$refs.form.validate();
			return new Promise((resolve, reject) => {
				if (flag && this.detailList.length>0) {
					resolve({
						employerTotalAmountVO: {
							beginDate: this.formatDate(this.form.beginDate),
							endDate: this.formatDate(this.form.endDate),
							policyTimeType: this.form.policyTimeType,
							price: this.totalAmount
						},
						detailList: this.detailList
					})
				} else {
					this.toast('保障信息或上传设备错误', 'error');
					resolve(false)
				}
			})
		},
		/*日期变化后获取起保终保日期*/
		dateChange(type) {
			this.setStartTimeOption().then(res=>{
				if(type!='endDate'&&this.form.beginDate){
					this.$set(this.form,'endDate',res.defaultEndDate)
				}
				if (this.form.beginDate&&this.form.endDate) {
					this.getPremium();
				}
			})
		},
		// 获取保障止期，父页面fillin也会用到
		getEffectiveDateEnd(params) {
			return this.$axios.post('/specialEquipment/timeAndPrice.json', params).then(res => {
				return res
			})
		},
		/*上传成功后获取数据*/
		uploadSuccess(res) {
			if(res.code!=10000000){
				this.toast(res.msg,'error')
				return
			}
			if(this.detailList.length>0){
				let list = res.data;
				list = list.concat(this.detailList);
				this.detailList = list;
			} else {
				this.detailList = res.data;
			}
			this.getPremium();
		},
		/*获取保费*/
		async getPremium() {
			if (this.detailList.length == 0) {
				this.totalAmount = 0
				return
			}
			this.detailList = this.detailList.map((item)=>{
				if(!item.status){
					return {
						...item,
						status:1
					}
				}
				return item
			})
			let obj = {
				detailList: this.detailList,
				policyTimeType: this.form.policyTimeType,
				beginDate: this.formatDate(this.form.beginDate),
				endDate: this.formatDate(this.form.endDate),
			}
			if (!obj.beginDate) return
			let res = await this.$axios.post('/specialEquipment/timeAndPrice.json', obj)
			res.detailList.forEach(item=>{
				this.detailList.forEach(item2=>{
					if(item2.code==item.code){
						item2.price = item.price;
						item2.beginDate = item.beginDate;
						item2.endDate = item.endDate;
					}
				})
			})
			this.$emit('set-amount', res.amount)
			this.totalAmount = res.amount;
		},
		// 添加工种
		addClick() {
			this.addFacilityTitle = '添加设备';
			this.addFacility = true;
		},
		// 删除
		del(index) {
			this.$Modal.confirm({
				title: '确定删除？',
				okText:'取消',
				cancelText:'确认',
				onOk: () => {
					
				},
				onCancel: () => {
					this.detailList.splice(index, 1)
					this.getPremium();
				}
			});
		}
	}
}
</script>
<style scoped lang="less">
.download-info {
	font-size: 16px;

	span {
		color: #FF9900;
		margin-left: 20px;
	}
}

.recognize {
	&-title {
		font-weight: bold;
	}

	&-total {
		font-size: 16px;
	}
}

.caseContainer {
	padding: 10px 0;
}

.subtitle {
	color: #FF9900;
	font-size: 16px;
	margin-left: 20px;
}

.downloadFile {
	margin-left: 20px;
	margin-right: 20px;
}

.errorMsg {
	font-size: 14px;
	color: red;
}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/forklift/recognize.vue